export default function Terms() {
  return (
    <div className="py-20 lg:py-28" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6">
        <p className="label-eyebrow mb-5">Terms of Service</p>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.0]">
          The fair-use agreement.
        </h1>
        <p className="mt-6 text-muted-foreground">Last updated: February 2026</p>

        <div className="mt-12 space-y-10 text-foreground/90 leading-relaxed">
          <Block title="1. Use of AVault">
            <p>AVault is licensed, not sold. The Free tier is offered without warranty for personal use. Pro features require an active subscription.</p>
          </Block>
          <Block title="2. Your data, your responsibility">
            <p>Because AVault is offline-first, your master password is the only key to your vault. We <em>cannot</em> recover it. You are responsible for backing up your vault file.</p>
          </Block>
          <Block title="3. No warranty">
            <p>AVault is provided &quot;as is&quot;, without warranty of any kind. We do our best to ship secure, audited code, but security is a process, not a guarantee.</p>
          </Block>
          <Block title="4. Acceptable use">
            <p>Don&apos;t use AVault to store content that&apos;s illegal in your jurisdiction, and don&apos;t reverse-engineer the binary to circumvent its licensing.</p>
          </Block>
          <Block title="5. Subscriptions & refunds">
            <p>Pro is billed monthly or yearly. Refunds within 14 days, no questions asked. Cancel anytime — your data remains accessible.</p>
          </Block>
          <Block title="6. Termination">
            <p>We may suspend Pro accounts that abuse our support resources or attempt to defraud our payment processor. Your local vault file is unaffected.</p>
          </Block>
          <Block title="7. Contact">
            <p>Questions? Email <span className="font-mono">legal@avault.app</span>.</p>
          </Block>
        </div>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-2xl font-bold tracking-tight mb-3">{title}</h2>
      <div className="text-muted-foreground">{children}</div>
    </section>
  );
}
